export default __webpack_public_path__ + "static/media/binance-coin.d8c61230.svg";